module.exports = __webpack_public_path__ + "static/media/menuCardsPositive1.08dd0986.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/illustrator-imgs/menuCardsPositive1.png
// module id = 81
// module chunks = 0